import { Component } from 'react';

export default class SafeImage extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        const { src } = this.props;
        return <img src={src} alt="" />;
    }
}
